import React from 'react';
import AnimateOnScroll from './AnimateOnScroll';

const SectionHeader = ({ badge, title, highlight, description, align = 'center' }) => {
  const alignClass = align === 'center' ? 'text-center mx-auto' : 'text-left';

  return (
    <AnimateOnScroll animation="fade-up">
      <div className={`mb-16 max-w-3xl ${alignClass}`}>
        {badge && (
          <span className="section-badge mb-4 inline-block">{badge}</span>
        )}
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
          {title}{' '}
          {highlight && <span className="gradient-text">{highlight}</span>}
        </h2>
        {description && (
          <p className="text-lg sm:text-xl text-gray-400 leading-relaxed">
            {description}
          </p>
        )}
        <div className={`section-divider mt-8 ${align === 'center' ? 'mx-auto' : ''}`} />
      </div>
    </AnimateOnScroll>
  );
};

export default SectionHeader;
